import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";

const About = () => {
  const { t } = useTranslation("common");

  return (
    <Layout title={t("about_us") || "About Us"}>
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md">
        <h1 className="text-h1 mb-6 text-gray-900 dark:text-white">
          {t("about_title") || "Our Story"}
        </h1>

        <div className="prose dark:prose-invert max-w-none">
          <p className="mb-4 text-body text-gray-700 dark:text-gray-300">
            {t("about_content_1") ||
              "Founded in 2023, ShopStore began with a simple mission: to make quality products accessible to everyone. What started as a small local business has grown into a global online retailer, serving customers in over 50 countries."}
          </p>

          <p className="mb-4 text-body text-gray-700 dark:text-gray-300">
            {t("about_content_2") ||
              "We believe in the power of technology to connect people with the things they love. Our team is passionate about curating a selection of products that bring joy, utility, and value to your life."}
          </p>

          <h2 className="text-h2 mt-8 mb-4 text-gray-900 dark:text-white">
            {t("our_values") || "Our Values"}
          </h2>

          <ul className="list-disc pl-6 space-y-2 text-body text-gray-700 dark:text-gray-300">
            <li>
              <strong>{t("customer_first") || "Customer First"}:</strong>{" "}
              {t("customer_first_desc") ||
                "We prioritize your satisfaction above all else."}
            </li>
            <li>
              <strong>{t("quality") || "Quality"}:</strong>{" "}
              {t("quality_desc") ||
                "We never compromise on the quality of our products."}
            </li>
            <li>
              <strong>{t("innovation") || "Innovation"}:</strong>{" "}
              {t("innovation_desc") ||
                "We are always looking for new ways to improve your shopping experience."}
            </li>
            <li>
              <strong>{t("sustainability") || "Sustainability"}:</strong>{" "}
              {t("sustainability_desc") ||
                "We are committed to reducing our environmental footprint."}
            </li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default About;
